<template>
  <div id="dashboard-overview" v-if="overview.data != null" v-loading="overview.loading">
    <el-row :gutter="20">
      <el-col :span="6" v-for="(item, index) in overview.data.cards" :key="index">
        <div class="data-card purple">
          <div class="card-info">
            <div class="title">
              <span>{{ item.title }}</span>
            </div>
            <div class="value">
              <span>{{ item.value }}</span>
            </div>
            <div class="description">
              <span>{{ item.description }}</span>
            </div>
          </div>
          <div class="card-icon">
            <i :class="item.icon"></i>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="statistics-container">
      <div class="overview-table-header">
        <h3>{{ $t("components.dashboard.overview.participantSegmentation") }}</h3>
        <!-- <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
          <el-button disabled icon="fas fa-download" size="mini" @click="downloadReport"></el-button>
        </el-tooltip> -->
      </div>

      <el-row :gutter="20">
        <el-col :span="16">
          <div class="group-list" v-for="(item, index) in overview.data.segmentations" :key="index">
            <div class="group-list-header">
              <div class="group-title">
                <i class="fas fa-square" :style="'color: ' + item.color"></i>
                <span>{{ item.title }}</span>
              </div>
              <div class="group-list-count">
                <!-- <span>{{item.tags.length}} etiket, toplam {{item.participantCount}} katılımcı</span> -->
                <span>{{ $t("components.dashboard.overview.labelTotal", [item.tags.length, item.participantCount]) }}</span>
              </div>
            </div>
            <div class="group-tags-container">
              <div class="tag-item" v-for="(inner, innerIndex) in item.tags" :key="'tag-' + innerIndex">
                <i class="fas fa-circle" :style="'color: ' + inner.color"></i>
                <span>{{ inner.title }}</span>
                <span>{{ inner.participantCount }}</span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="pie-chart-container">
            <div ref="overview-chart" id="overview-chart" class="chart"></div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { C } from "caniuse-lite/data/agents";

export default {
  components: {},
  name: "Overview",
  data() {
    return {
      chart: null
    };
  },
  methods: {
    downloadReport() {
      axios.post("report/generalstatistics", {}).then(res => {
        this.$message.success(res.data.alert.message);
      });
    },
    createPieChart() {
      var chart = am4core.create("overview-chart", am4charts.PieChart);
      chart.data = this.overview.data.chartData.datasets;
      chart.radius = am4core.percent(100);
      chart.hiddenState.properties.opacity = 0;
      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "key";
      pieSeries.slices.template.propertyFields.fill = "color";
      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;
      chart.pieSeries = pieSeries;
      // chart.legend = new am4charts.Legend();
      // chart.legend.maxWidth = undefined;
      // chart.legend.valueLabels.template.align = "left";
      // chart.legend.valueLabels.template.textAlign = "end";
      chart.responsive.enabled = true;
      this.chart = chart;
    }
  },

  async mounted() {
    if (this.overview.data == null) {
      await this.$store.dispatch("getOverview", {});
      this.$nextTick(() => {
        this.createPieChart();
      });
    } else {
      if (this.chart == null) {
        this.createPieChart();
      }
    }

    this.$watch("overview.loading", function() {
      this.chart.data = this.overview.data.chartData.datasets;
    });
  },

  computed: {
    overview() {
      return this.$store.getters.getDashboardOverview;
    }
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },

  watch: {}
};
</script>

<style lang="less">
#dashboard-overview {
  .group-list {
    .group-list-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background-color: #f1f1f1;
      width: 100%;
      padding: 8px 12px;
      border-radius: 8px;
      .group-title {
        display: flex;
        justify-content: center;
        align-items: center;

        i {
          color: #292f3b;
          margin-right: 6px;
        }
        span {
          color: #292f3b;
          font-weight: 500;
          font-size: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 245px;
        }
      }
      .group-list-count {
        span {
          text-align: right;
          color: #292f3b;
          font-weight: 400;
          font-size: 13px;
        }
      }
    }

    .group-tags-container {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      width: 100%;
      gap: 0.5rem;
      padding: 12px 0px;

      .tag-item {
        max-width: 100%;
        border-radius: 8px;
        border: 1px solid #f1f1f1;
        padding: 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        i {
          margin-right: 4px;
        }

        span {
          font-weight: 400;
          color: #292f3b;
          font-size: 13px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 145px;
          margin-right: 8px;

          &:last-child {
            background-color: #f1f1f1 !important;
            border-radius: 6px;
            font-size: 13px;
            color: #292f3b;
            font-weight: 600;
            top: 10px;
            right: 10px;
            padding: 2px 8px;
            margin-left: auto;
            margin-right: 0px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Overview.vue